<template>
  <div class="supply-holder">
    <div class="columns is-multiline">
      <div class="column is-6">
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-small is-left">
              <i class="mdi mdi-magnify"></i>
            </span>
            <input
              class="input"
              type="text"
              placeholder="Buscar insumo por nome"
              v-model.trim="searchText"
            />
          </div>
        </div>
      </div>

      <div class="column is-6">
        <div class="buttons is-right">
          <button class="button is-primary" @click="openCreateEditModal()">
            Novo Insumo
          </button>
        </div>
      </div>
      <div class="column is-12" v-if="supplies.length > 0">
        <div class="table-holder">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th class="order-column" @click="orderBy('name')">
                  <span>Nome</span>
                  <i class="mdi mdi-sort-ascending" v-if="filterAsc.name"></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'name'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('batch')">
                  <span>Lote</span>
                  <i class="mdi mdi-sort-ascending" v-if="filterAsc.batch"></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'batch'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('manufacturer')">
                  <span>Fornecedor</span>
                  <i
                    class="mdi mdi-sort-ascending"
                    v-if="filterAsc.manufacturer"
                  ></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'manufacturer'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('nfNumber')">
                  Nota Fiscal
                  <i
                    class="mdi mdi-sort-ascending"
                    v-if="filterAsc.nfNumber"
                  ></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'nfNumber'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('price')">
                  Preço
                  <i class="mdi mdi-sort-ascending" v-if="filterAsc.price"></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'price'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('size')">
                  Quantidade
                  <i class="mdi mdi-sort-ascending" v-if="filterAsc.size"></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'size'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('purchaseDate')">
                  Data de Compra
                  <i
                    class="mdi mdi-sort-ascending"
                    v-if="filterAsc.purchaseDate"
                  ></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'purchaseDate'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('expirationDate')">
                  Data de Vencimento
                  <i
                    class="mdi mdi-sort-ascending"
                    v-if="filterAsc.expirationDate"
                  ></i>
                  <i
                    class="mdi mdi-minus"
                    v-else-if="selectedOrder !== 'expirationDate'"
                  ></i>
                  <i class="mdi mdi-sort-descending" v-else></i>
                </th>
                <th class="order-column" @click="orderBy('')">Opções</th>
              </tr>
            </thead>
            <tbody class="content-body">
              <tr v-for="supply in supplies" :key="supply.id">
                <th>{{ supply.ingredient.name }}</th>
                <th>{{ supply.batch }}</th>
                <th>{{ supply.manufacturer.name }}</th>
                <th>{{ supply.nfNumber }}</th>
                <th>{{ supply.price || 0 | currency }}</th>
                <th>{{ supply.size || 0 }}Kg</th>
                <th>{{ supply.purchaseDate | moment("DD/MM/YYYY") }}</th>
                <th>{{ supply.expirationDate | moment("DD/MM/YYYY") }}</th>
                <th class="options-holder">
                  <a class="option" @click="openCreateEditModal(supply)"
                    >Editar</a
                  >
                  <a class="option" @click="remove(supply)">Excluir</a>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
        <paginate
          v-model="currentPage"
          :page-count="totalPages"
          :page-range="3"
          :click-handler="getData"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'ml-pagination pagination-sm'"
          :prev-class="'page-item'"
          :next-class="'page-item'"
          :next-link-class="'page-link'"
          :page-link-class="'page-link'"
          :page-class="'page-item'"
        >
        </paginate>
      </div>
      <div class="column is-12" v-else>
        <div class="no-items-to-show-msg">
          Nenhum insumo foi encontrado.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import CreateEditSupplyModal from "../components/supply/CreateEditSupplyModal";
import NotificationsWrapper from "../helpers/NotificationsWrapper";
import utils from "../helpers/debounce";
export default {
  name: "Supplies",
  data: () => ({
    currentPage: 1,
    searchText: "",
    selectedOrder: "name",
    filterAsc: {
      name: true,
      manufacturer: false,
      batch: false,
      nfNumber: false,
      price: false,
      size: false,
      purchaseDate: false,
      expirationDate: false
    }
  }),
  watch: {
    searchText: function() {
      this.getPetByText();
    }
  },
  computed: {
    ...mapState({
      supplies: state => state.supply.supplies,
      isLoadingData: state => state.supply.loading,
      totalPages: state => state.supply.totalPages
    })
  },
  methods: {
    ...mapActions({
      getSupplies: "supply/getSupplies",
      removeSupply: "supply/removeSupply"
    }),
    ...mapMutations({
      resetFilters: "supply/resetFilters",
      setSupplyFilters: "supply/setQueryFilters",
      setPage: "supply/setPage"
    }),
    orderBy(param) {
      let sort = "";
      if (param === "name") {
        sort = "ingredient";
      } else {
        sort = param;
      }
      sort += ",";
      sort += !this.filterAsc[param] ? "asc" : "desc";

      this.selectedOrder = param;
      let query = {
        size: 10,
        page: 0,
        sort: sort
      };

      if (this.searchText) {
        query.name = this.searchText;
      }

      this.changeOrderIcon(param);
      this.setSupplyFilters(query);
      this.getSupplies();
    },
    changeOrderIcon(param) {
      Object.keys(this.filterAsc).forEach(k => {
        if (param === k) {
          this.filterAsc[k] = !this.filterAsc[k];
        } else {
          this.filterAsc[k] = false;
        }
      });
    },
    openCreateEditModal(supply) {
      this.$modal.show(
        CreateEditSupplyModal,
        { supplyParam: Object.assign({}, supply) },
        {
          width: "700px",
          height: "auto",
          adaptive: true,
          scrollable: true,
          clickToClose: false
        },
        {
          closed: () => {
            this.getSupplies();
          }
        }
      );
    },
    getData(pageNum) {
      const page = pageNum - 1;
      this.currentPage = pageNum;
      this.setPage(page);
      this.getSupplies();
    },
    remove(supply) {
      this.$modal.show("dialog", {
        title: "Aviso de exclusão!",
        text: `Você deseja excluir o insumo ${supply.ingredient.name}?`,
        buttons: [
          {
            title: "Excluir",
            class: "vue-dialog-button error",
            handler: () => {
              this.removeSupply(supply.id)
                .then(() => {
                  NotificationsWrapper.success("Insumo excluído com sucesso!");
                  this.$modal.hide("dialog");
                  this.getSupplies();
                })
                .catch(() => {
                  NotificationsWrapper.error(
                    "Não foi possível remover o insumo!"
                  );
                });
            }
          },
          {
            title: "Cancelar", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.,
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    }
  },
  mounted() {
    this.getPetByText = utils.debounce(() => {
      this.resetFilters();
      this.setSupplyFilters({ name: this.searchText, limit: 5 });
      this.getSupplies();
    }, 300);
  },
  created() {
    this.getSupplies();
    this.$store.commit("setSelectedViewTitle", "Insumos");
  }
};
</script>

<style lang="scss" scoped>
.order-column {
  &:hover {
    cursor: pointer;
  }
  span {
    margin-right: 5px;
  }
}
.content-body {
  font-size: 14px;
}
</style>
